export var VendorPaymentTypeEnum;
(function (VendorPaymentTypeEnum) {
    VendorPaymentTypeEnum["CASH"] = "CASH";
    VendorPaymentTypeEnum["CREDIT_CARD"] = "CREDIT_CARD";
    VendorPaymentTypeEnum["GIFT_CARD"] = "GIFT_CARD";
    VendorPaymentTypeEnum["OTHER"] = "OTHER";
})(VendorPaymentTypeEnum || (VendorPaymentTypeEnum = {}));
//# sourceMappingURL=VendorPaymentTypeEnum.js.map